import type { ReactNode } from "react";

/**
 * The outermost app frame: everything fades in once on first paint. App chrome
 * rather than anything a screen composes, so it lives here beside the router.
 */
export function AppFadeInShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-[80vh] animate-[fadein_0.3s] rounded-[5px] p-0">
      {children}
    </div>
  );
}
